import React from 'react';
import styles from './tile-wrapper.scss';

export const TileWrapper: React.FC<React.PropsWithChildren> = ({ children }) =>
  <div className={styles.tileWrapper}>
    {children}
  </div>;
